/** Shared Tailwind classes for legal / policy pages (light + dark). */

export const legalSectionTitle =
  'text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3';

export const legalBodyText = 'space-y-6 text-gray-700 dark:text-gray-300 leading-relaxed';

export const legalLinkClass =
  'text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300';

export const legalNoticeBox =
  'text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-4 dark:text-amber-200 dark:bg-amber-950/40 dark:border-amber-800';

export const legalTableHead = 'py-3 pr-4 font-semibold text-gray-900 dark:text-gray-100';

export const legalTableCell = 'py-3 pr-4 text-gray-700 dark:text-gray-300';

export const legalTableRow = 'border-b border-gray-200 dark:border-gray-700 align-top';
